import { FiShare2, FiTrash2 } from "react-icons/fi"; // Import delete icon as well
import styles from './adminDropdown.module.css'
import { CiMenuKebab } from "react-icons/ci";
import { useState } from "react";


function AdminDropdown({ handleShare, postId, openDeleteModal }) {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  // Toggle the dropdown menu
  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  // Function to handle delete button click
  const handleDeleteClick = () => {
    
    setDropdownVisible(false); // Close the dropdown
    openDeleteModal(postId); // Call the handleDelete function passed as prop
  };

  // Function to handle share button click
  const handleShareClick = () => {
    setDropdownVisible(false); // Close the dropdown
    handleShare(postId); // Call the handleShare function passed as prop
  };
  return (
    <div className={styles.dropdownWrapper}>
      {/* Three-dot vertical icon as the toggle button */}
      <CiMenuKebab className={styles.moreIcon} onClick={toggleDropdown} />
      {isDropdownVisible && (
        <div className={styles.dropdown}>
          <p onClick={handleShareClick}>
            <FiShare2 /> Share
          </p>
          <p onClick={handleDeleteClick}>
            <FiTrash2 /> Delete
          </p>
        </div>
      )}
    </div>
  );
}


export default AdminDropdown;